// extracted by mini-css-extract-plugin
export default {"header":"TooltipContent_header__2EqZ8","subheader":"TooltipContent_subheader__VyKhC"};